<template>
  <div class="min-h-screen bg-gray-100 flex items-center justify-center p-4">
    <div class="bg-white shadow-lg rounded-lg p-8 max-w-md w-full text-center">
      <h1 class="text-3xl font-bold text-red-600 mb-4">Overdue Invoice Alert</h1>
      <p class="text-gray-700 text-lg mb-6">
        It seems there's an overdue payment associated with your account. Please contact your administrator to avoid any service disruptions..
      </p>
      <div class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
        <p class="font-semibold">Action Required</p>
        <p>Reach out to your administrator.</p>
      </div>
      <div class="flex justify-center">
        <button
            @click="contactAdmin"
            class="bg-blue-600 text-white font-semibold py-2 px-6 rounded hover:bg-blue-700 transition duration-300"
        >
          Contact Admin
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverdueInvoice',
  methods: {
    contactAdmin() {
      // This could open an email client or redirect to a contact form
      window.location.href = 'mailto:admin@yourcompany.com?subject=Overdue%20Invoice%20Inquiry';
    }
  }
}
</script>

<style scoped>
/* Tailwind CSS is assumed to be included in the project */
/* Additional custom styles can be added here if needed */
</style>